export default __webpack_public_path__ + "static/media/tileBg1.47aea76d.png";